import moment from "moment";

const formatDateTime = value => {
  return value
    ? moment(new Date(value), "DD/MM/YYYY HH:mm:ss").format(
        "DD/MM/YYYY HH:mm:ss"
      )
    : null;
};

export default formatDateTime;
